module.exports = __webpack_public_path__ + "static/media/shrimp_tempura.80f14eae.webp";